const isPresumablyDesktopByHeight = window.matchMedia('(min-height: 800px)').matches;

export default isPresumablyDesktopByHeight;
